export const DASHBOARD_METADATA = "dashboard:data";
